import $ from 'jquery';
import {component} from "@reduct/component";

import app from '../../assembler';

function scrollTo(target) {
	$('html, body').animate({
		scrollTop: $(target).offset().top - $('.siteHeader').height()
	}, 800);
}

@component()
class ScrollTo {
	constructor() {
		const $el = $(this.getElement());
		const data = $el.data();
		let target = data.target;

		switch (data.target) {
			case 'next':
				target = $el.parent().next().get(0);
				break;
			case 'top':
				target = document.body.children[0];
				break;
			default:
				break;
		}

		this.getElement().addEventListener('click', e => {
			e.preventDefault();
			e.stopImmediatePropagation();

			if (target) {
				scrollTo(target);
			} else {
				console.error('No target specified in the ScrollTo component.', el);
			}
		});
	}
}

app.register(ScrollTo, 'ScrollTo');
